import moment from 'moment'
import { rgba } from 'polished'

import logError from 'utils/errorLogger'
import { describeFrequency } from 'utils/frequency'

import { theme } from 'styles/theme'

export const getChargeEnum = (status: string) => {
  switch (status) {
    case 'boleto':
      return 'Boleto'
    case 'cash':
      return 'Dinheiro'
    case 'credit_card':
      return 'Cartão de crédito'
    case 'other':
      return 'Outros'
    case 'pix':
      return 'Pix'
    case 'transfer':
      return 'Transferência (TED/DOC)'
    case 'credit_card_recurring':
      return 'Cartão recorrente'
    case 'credit_card_installments':
      return 'Cartão parcelado'
    case 'boleto_pix':
      return 'Pix'
    case 'direct_payment':
      return 'Recebimento manual'
    default:
      logError(`Erro ao mapear status da cobrança : ${status} (getChargeEnum)`)
      return 'Status desconhecido'
  }
}

export const getHoverText = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        text: 'A recorrência está sendo criada'
      }
    case 'active':
      return {
        text: 'A recorrência está ativa e vai gerar as cobranças programadas'
      }
    case 'finished':
      return {
        text: 'A recorrência chegou ao final dos ciclos programados'
      }
    case 'cancelled':
      return {
        text: 'A recorrência foi cancelada e não gera cobranças novas'
      }
    case 'expiring':
      return {
        text: 'A recorrência está próxima do último ciclo programado'
      }
    default:
      logError(`Erro ao mapear o texto da tooltip recorrências: ${status}`)
      return {
        text: 'Status desconhecido'
      }
  }
}

export const reasonTypeMapper = {
  wrong_billing: 'Cobrança indevida',
  service_cancellation: 'Cliente cancelou a prestação de serviços',
  issue_error: 'Erro na emissão',
  non_payment: 'Cliente inadimplente',
  other: 'Outros motivos'
}

export const getStatus = (status: string) => {
  switch (status) {
    case 'cancelled':
      return {
        color: rgba(theme.palette.error[300], 0.3),
        fontColor: theme.palette.error[300],
        label: 'Cancelada'
      }
    case 'active':
      return {
        fontColor: theme.palette.primary[200],
        color: theme.palette.primary[500],
        label: 'Ativa'
      }
    case 'finished':
      return {
        color: theme.palette.primary.main,
        label: 'Finalizada'
      }
    case 'pending':
      return {
        label: 'Pendente',
        color: theme.palette.neutral[700],
        fontColor: '#777877',
        disabled: true
      }
    default:
      logError(
        `Erro ao mapear status da cobrança (como ela se encontra pending, finished...): ${status} (getStatus)`
      )
      return {
        label: 'Status desconhecido',
        color: theme.palette.neutral[700],
        fontColor: '#777877',
        disabled: true
      }
  }
}

export const getStatusOptionCharge = (status: string, dueDate?: string) => {
  const today = moment().startOf('day').format('YYYY-MM-DD')
  switch (status) {
    case 'pending':
      return {
        label: 'Pendente',
        color: theme.palette.neutral[700],
        disabled: true
      }
    case 'created_payment':
      return {
        label: 'Pendente',
        color: theme.palette.neutral[700],
        disabled: true
      }
    case 'open_payment':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return {
          label: 'Atrasada',
          color: theme.palette.alert[300]
        }
      }
      return {
        label: 'Aberta',
        color: theme.palette.secondary[300]
      }
    case 'no_payment':
      return {
        label: 'Expirada',
        color: theme.palette.error[300]
      }
    case 'expiring':
      return {
        color: theme.palette.error[400],
        label: 'Expirada'
      }
    case 'paid':
      return {
        label: 'Paga',
        color: theme.palette.primary.main
      }
    case 'cancelling':
      return {
        label: 'Cancelada',
        color: theme.palette.error[300]
      }
    case 'cancelled':
      return {
        label: 'Cancelada',
        color: theme.palette.error[300]
      }
    case 'expired':
      return {
        label: 'Expirada',
        color: theme.palette.error[300]
      }
    case 'suspended':
      return {
        label: 'Suspensa',
        color: theme.palette.neutral[700]
      }
    default:
      logError(`Erro ao mapear status da tabela cobranças: ${status}`)

      return {
        label: 'Status desconhecido',
        color: theme.palette.neutral[300]
      }
  }
}

export const getStatusStyleCharge = (status: string, dueDate?: string) => {
  const today = moment().startOf('day').format('YYYY-MM-DD')
  switch (status) {
    case 'pending':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'created_payment':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'open_payment':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return {
          color: theme.palette.alert[300],
          background: rgba(theme.palette.alert[400], 0.3)
        }
      }
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'no_payment':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'paid':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'cancelling':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'cancelled':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'expired':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'suspended':
      return {
        color: theme.palette.neutral[700],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    default:
      logError(`Erro ao mapear estilos da tabela cobranças: ${status}`)

      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
  }
}

export const getFrequency = (
  status: string,
  frequencyType?: string,
  frequencyNumber?: number
) => {
  const label = describeFrequency(status, frequencyType, frequencyNumber)
  if (label) return label

  logError(`Erro ao mapear status da frequencia: ${status} (getFrequency)`)
  return 'Status desconhecido'
}

export const getAdjustmentTypeLabel = (type: string) => {
  switch (type) {
    case 'ipca':
      return 'IPCA'
    case 'igpm':
      return 'IGP-M'
    case 'customized':
      return 'Personalizado'
    default:
      return 'Desconhecido'
  }
}
